import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, mergeMap, Observable, of } from 'rxjs';
import { SessionService } from './storage/session.service';
import { ApiService } from './api.service';
import { PreferedLanguagePayload, TranslateModel, Translation } from '../models/translation';
import { Language } from '../constants/language';
import { ListItem } from '../models/listItem';

const controllerRoute = '/translate';

@Injectable()
export class TranslationService {
    public translationData: any;

    constructor(
        private apiService: ApiService,
        private sessionService: SessionService,
        private http: HttpClient
    ) { }

    public getSupportedLanguageList(): Observable<Object> {
        return this.apiService.get(`${controllerRoute}/supported-codes`).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    public translate(
        value: string,
        jsonKey: string,
        isHTML: boolean
    ): Observable<string> {
        if (jsonKey?.includes(" ")) jsonKey = jsonKey.replace(/\s+/g, '');
        
        if (this.sessionService.session.language == Language.en) {
            this.translationData = null;
            return of(value);
        }

        if (!value) return of('');

        if (jsonKey) {
            switch (this.sessionService.session.language) {
                case Language.es:
                    return this.jsonSpanishTranslationData().pipe(
                        map((translatedFile) => {
                            if (translatedFile[jsonKey]) {
                                return translatedFile[jsonKey] as string;
                            } else {
                                return null;
                            }
                        }),
                        mergeMap((translation) =>
                            this.getTranslation(value, jsonKey, isHTML, translation)
                        )
                    );

                default:
                    return this.getTranslation(value, jsonKey, isHTML);
            }
        } else {
            return this.getTranslation(value, jsonKey, isHTML);
        }
    }

    private jsonSpanishTranslationData(): Observable<any> {
        if (this.translationData) return of(this.translationData);

        return this.http.get<ListItem[]>('../../assets/translations/es.json').pipe(
            map((data) => {
                this.translationData = data;
                return this.translationData;
            })
        );
    }

    public getTranslation(
        value: string,
        jsonKey: string,
        isHTML: boolean,
        newValue?: string
    ): Observable<string> {
        if (newValue) return of(newValue);

        const l_Translation = new Translation();
        l_Translation.english = value;
        l_Translation.key = jsonKey;
        l_Translation.code = this.sessionService.session.language;
        l_Translation.isHtml = isHTML;

        return this.apiService.postNoSpinner(`${controllerRoute}/portal-translation`, l_Translation)
            .pipe(
                map((response: TranslateModel) => {
                    return response.translation;
                })
            );
    }

    public savePreferedLanguage(languageCode: string) {
        if (this.sessionService.session.isAgent || this.sessionService.session.isAgent) {
            return null;
        } else {

            let payload: PreferedLanguagePayload = new PreferedLanguagePayload();
            payload.languageCode = languageCode;
            payload.systemNumber = this.sessionService.session.member.systemNumber

            return this.apiService
                .post(`${controllerRoute}/prefered-language`, payload)
                .pipe(
                    map((response: any) => {
                        return response
                    })
                );
        }
    }
}
